import { formatVienna } from './datetime'

/*
 * Freigabe zur Überarbeitung (Anforderung #230).
 *
 * Ob die Freigabe gerade gilt, rechnet der Server (`revisionRelease` am Profil:
 * `active`, `until`, `openEnded`, `expired`) — die Oberfläche rechnet keine
 * Frist nach. Hier steht nur, wie sie zu lesen ist.
 *
 * `until` ist der Zeitpunkt, an dem die Freigabe endet: 00:00 Uhr Wiener Zeit
 * am Tag **nach** dem letzten freigegebenen Tag. Gezeigt wird der letzte Tag.
 */
export const isReleaseActive = release => !!release?.active

export const releaseLastDay = until => {
	if (!until) return ''
	const ende = new Date(until)
	if (Number.isNaN(ende.getTime())) return ''
	return formatVienna(new Date(ende.getTime() - 1), 'dd.MM.yyyy')
}

/** Der Hinweis für die Schüler:innen über dem freigegebenen Abschnitt. */
export const releaseHint = (t, release) => {
	if (!isReleaseActive(release)) return null
	return release.openEnded
		? t('Released for revision by the administration until further notice')
		: t('Released for revision by the administration until {{date}}', { date: releaseLastDay(release.until) })
}

/** Vorschlag für das Ende einer neuen Freigabe: heute + 14 Tage (Wiener Kalender). */
export const RELEASE_DEFAULT_DAYS = 14

export const defaultReleaseDay = (now = new Date()) =>
	formatVienna(new Date(now.getTime() + RELEASE_DEFAULT_DAYS * 24 * 60 * 60 * 1000), 'yyyy-MM-dd')
